import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { useGetUserViewCampaigns } from '../../hooks/useGetUserViewCampaigns';
import { useCampaignsToShow } from '../../hooks/useCampaignsToShow';
import { Wrapper } from './StyledComponents';
import { CampaignIcon } from './CampaignIcon.jsx';
import { MoreCampaignsMenu } from './MoreCampaignsMenu.jsx';
import { Grid } from '../../../../assets';

export const UserViewCampaigns = ({ isMoments }) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const campaignUuid = urlParams.get('campaign_id');
  const showArchivedCampaignSelector = useSelector(
    state => state.demoData.hasArchivedCampaignSelector,
  );
  const {
    campaigns,
    selectedCampaignUuid,
    setSelectedCampaign,
  } = useGetUserViewCampaigns({ campaignUUid: campaignUuid });

  const {
    recentCampaigns,
    olderCampaigns,
    wrapperRef,
    olderCampaignsByYear,
  } = useCampaignsToShow({
    campaigns,
    showArchivedCampaignSelector,
  });

  return (
    <Wrapper ref={wrapperRef}>
      {isMoments && (
        <CampaignIcon
          tileImage={Grid}
          onClick={() => {
            setSelectedCampaign({});
          }}
          isSelected={selectedCampaignUuid === null}
          name="Home"
        />
      )}

      {recentCampaigns.map(campaign => (
        <CampaignIcon
          {...campaign}
          key={campaign.uuid}
          onClick={() => {
            setSelectedCampaign(campaign);
          }}
          isSelected={campaign.uuid === selectedCampaignUuid}
        />
      ))}
      {olderCampaigns.length > 0 && (
        <MoreCampaignsMenu
          selectedCampaignUuid={selectedCampaignUuid}
          setSelectedCampaign={setSelectedCampaign}
          campaigns={olderCampaigns}
        />
      )}
      {showArchivedCampaignSelector &&
        Object.entries(olderCampaignsByYear).map(([year, campaignsByYear]) => (
          <MoreCampaignsMenu
            key={year}
            selectedCampaignUuid={selectedCampaignUuid}
            setSelectedCampaign={setSelectedCampaign}
            campaigns={campaignsByYear}
            year={year}
          />
        ))}
    </Wrapper>
  );
};

UserViewCampaigns.propTypes = {
  isMoments: PropTypes.bool,
};
